<div>
  <label>
    {{ label }}
    <span class="hint" *ngIf="hint">— {{ hint }}</span>
  </label>
  <div
    class="bciti-select bciti-select-input"
    [class.disabled]="disabled"
    (click)="toggleDropdown()"
    (keydown.enter)="toggleDropdown()"
    (keydown.space)="$event.preventDefault(); toggleDropdown()"
    role="button"
    [attr.tabindex]="disabled ? -1 : 0"
    [attr.aria-disabled]="disabled"
    #dropreference
  >
    <ul>
      <li>
        <span *ngIf="selected"> {{ selected.label }}  </span>
        <span *ngIf="!selected" class="placeholder"> {{ placeholder }} </span>
        <span class="icon icon-caret-down"></span>
      </li>
    </ul>
    <app-user-card-select-dropdown [reference]="dropreference" #dropdown>
      <div class="bciti-select bciti-select-dropdown no-margin">
        <ul>
          <ng-container *ngFor="let option of options">
            <li (click)="select(option)" *ngIf="option !== selected">
              {{option.label}}
            </li>
          </ng-container>
        </ul>
      </div>
    </app-user-card-select-dropdown>
  </div>
</div>